import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import global from './global';
import alert from './alert';
import auth from './auth';
import profile from './profile';
import create from './create';
import teams from './teams';
import users from './users';
import agreements from './agreements';
import works from './works';
import workOwnerships from './workOwnerships';
import deals from './deals';
import invites from './invites';
import dealBlocks from './dealBlocks';
import dealMessages from './dealMessages';
import dealUsers from './dealUsers';
import coreg from './coreg';
import payment from './payment';
import publishers from './publishers';

export default combineReducers({
  routing: routerReducer,
  global,
  alert,
  auth,
  profile,
  teams,
  users,
  create,
  agreements,
  works,
  workOwnerships,
  deals,
  invites,
  dealBlocks,
  dealMessages,
  dealUsers,
  coreg,
  payment,
  publishers,
});



// WEBPACK FOOTER //
// src/redux/reducers/index.js